import * as tslib_1 from "tslib";
import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../_constants/validation-format-constants';
const ɵ0 = () => Date, ɵ1 = () => Date;
export class VendorMissingBillsParameterDto {
    getQueryString() {
        let url = '';
        if (this.isResolved !== null) {
            if (!url) {
                url = `?isResolved=${this.isResolved}`;
            }
            else {
                url += `&isResolved=${this.isResolved}`;
            }
        }
        if (this.fromDate) {
            if (!url) {
                url = `?fromDate=${dateJSONTransformer(this.fromDate)}`;
            }
            else {
                url += `&fromDate=${dateJSONTransformer(this.fromDate)}`;
            }
        }
        if (this.toDate) {
            if (!url) {
                url = `?toDate=${dateJSONTransformer(this.toDate)}`;
            }
            else {
                url += `&toDate=${dateJSONTransformer(this.toDate)}`;
            }
        }
        if (this.communityId) {
            if (!url) {
                url = `?communityId=${this.communityId}`;
            }
            else {
                url += `&communityId=${this.communityId}`;
            }
        }
        return url;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], VendorMissingBillsParameterDto.prototype, "fromDate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], VendorMissingBillsParameterDto.prototype, "toDate", void 0);
export { ɵ0, ɵ1 };
